import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { css } from '@styled-system/css';
import styled from 'styled-components';
import { Box } from '@honda-canada/design-system-react';
var Container = styled(Box)(css({
    outline: 'none',
    width: '85%',
    maxWidth: '1110px',
    height: 'auto',
    margin: '0 auto',
    padding: ['0', '20px 0'],
}));
var GraphSection = styled(Box)(function (_a) {
    var theme = _a.theme;
    return css({
        display: 'block',
        width: '100%',
        height: 'fit-content',
        minWidth: '30px',
        minHeight: '100px',
        '.graphic-container .item-container ': {
            borderBottom: "1px solid ".concat(theme.colors.grey[1]),
            padding: ['30px 0', '30px 0 30px 30px'],
        },
        '.graphic-container:not(.static-number):first-child .item-container ': {
            padding: ['30px 0', '10px 0 30px 30px'],
        },
    });
});
var ContentContainer = styled(Box)(css({
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    variants: {
        mobile: {
            flexDirection: 'column',
            padding: '0',
            alignItems: 'center',
        },
    },
}));
var Content = styled(Box)(css({
    flex: '1',
    maxWidth: '540px',
}));
var ChartsContainer = function (_a) {
    var rendering = _a.rendering;
    if (!rendering) {
        return null;
    }
    return (React.createElement(Container, { "data-testid": "charts-container" },
        React.createElement(ContentContainer, null,
            React.createElement(Content, null,
                React.createElement(GraphSection, null,
                    React.createElement(Placeholder, { name: "charts-content", rendering: rendering }))))));
};
export default ChartsContainer;
